import userRoles from '../../constants/userRoles';
import HeadDashboardPage from '../../pages/Head/Dashboard';
import HeadDashboardPageV3 from '../../pages/Head/Dashboard/v3';
import GrowPage from '../../pages/Head/Grow';
import GrowPageV3 from '../../pages/Head/Grow/v3';
import HeadDepartmentsPage from '../../pages/Head/HeadDepartmentsPage';
import LevelsPage from '../../pages/Head/Levels';
import LevelsPageV3 from '../../pages/Head/Levels/v3';
import ReviewHistoryPage from '../../pages/Head/ReviewHistory';
import ReviewHistoryPageV3 from '../../pages/Head/ReviewHistory/v3';
import ReviewsPage from '../../pages/Head/Reviews';
import SpecificReview from '../../pages/Head/Reviews/HeadSpecificReview';
import ReviewsPageV3 from '../../pages/Head/Reviews/v3';
import SpecificReviewV3 from '../../pages/Head/Reviews/v3/SpecificReview';
// Skills page temporarily disabled
// import SkillsPage from '../../pages/Head/Skills/index';
import UsersPage from '../../pages/Head/Users';
import UserSkillsPage from '../../pages/Head/Users/components/Skills';
import UserPersonalTasksPage from '../../pages/Head/Users/components/UserPersonalTasks';
import UsersPageV3 from '../../pages/Head/Users/v3';
import HeadDepartmentsPageV3 from '../../pages/Head/v3/HeadDepartmentsPage';
import HeadPageTemplate from '../../templates/HeadPageTemplate';
import HeadPageTemplateV3 from '../../templates/HeadPageTemplateV3';

const adminRoutes = [
  {
    path: '/head/departments',
    title: 'Departments',
    requiredRoles: [userRoles.HEAD],
    component: () => <HeadDepartmentsPageV3 title="Head Panel" />,
  },
  {
    path: '/v1-head/departments',
    title: 'Departments (Legacy)',
    requiredRoles: [userRoles.HEAD],
    component: ({ crumbs }) => <HeadDepartmentsPage crumbs={crumbs} title="Departments" />,
  },
  {
    path: '/head/departments/:department/grow',
    title: 'Grow',
    requiredRoles: [userRoles.ADMIN, userRoles.HEAD],
    component: () => <HeadPageTemplateV3 component={GrowPageV3} title="Grow" />,
  },
  {
    path: '/v1-head/departments/:department/grow',
    title: 'Grow (Legacy)',
    requiredRoles: [userRoles.ADMIN, userRoles.HEAD],
    component: ({ crumbs }) => (
      <HeadPageTemplate crumbs={crumbs} component={GrowPage} title="Grow" />
    ),
  },
  {
    path: '/head/departments/:department/users',
    title: 'Users',
    requiredRoles: [userRoles.HEAD],
    component: () => <HeadPageTemplateV3 component={UsersPageV3} title="Users" />,
  },
  {
    path: '/v1-head/departments/:department/users',
    title: 'Users (Legacy)',
    requiredRoles: [userRoles.HEAD],
    component: ({ crumbs }) => (
      <HeadPageTemplate crumbs={crumbs} component={UsersPage} title="Users" />
    ),
  },
  {
    path: '/head/departments/:department/users/:id/personal-tasks/',
    title: 'Personal tasks',
    requiredRoles: [userRoles.HEAD],
    component: ({ crumbs }) => {
      const filteredCrumbs = crumbs.filter((crumb) => crumb.title !== 'Personal tasks');
      return (
        <HeadPageTemplate
          crumbs={filteredCrumbs.concat([
            {
              path: `/head/departments/${
                filteredCrumbs[filteredCrumbs.length - 1].path
              }/personal-tasks/`,
              title: 'Personal tasks',
            },
          ])}
          component={UserPersonalTasksPage}
          title="User personal tasks"
        />
      );
    },
  },
  // Skills page temporarily disabled
  // {
  //   path: '/head/departments/:department/skills',
  //   title: 'Skills',
  //   requiredRoles: [userRoles.HEAD],
  //   component: ({ crumbs }) => (
  //     <HeadPageTemplate crumbs={crumbs} component={SkillsPage} title="Skills" />
  //   ),
  // },
  {
    path: '/head/departments/:department/users/:id',
    title: 'Skills',
    requiredRoles: [userRoles.HEAD],
    component: ({ crumbs }) => (
      <HeadPageTemplate
        crumbs={crumbs.concat([
          {
            path: crumbs[crumbs.length - 1].path,
            title: 'Skills',
          },
        ])}
        component={UserSkillsPage}
        title="User Skills"
      />
    ),
  },
  {
    path: '/head/departments/:department/levels',
    title: 'Levels',
    requiredRoles: [userRoles.HEAD],
    component: () => <HeadPageTemplateV3 component={LevelsPageV3} title="Levels" />,
  },
  {
    path: '/v1-head/departments/:department/levels',
    title: 'Levels (Legacy)',
    requiredRoles: [userRoles.HEAD],
    component: ({ crumbs }) => (
      <HeadPageTemplate crumbs={crumbs} component={LevelsPage} title="Levels" />
    ),
  },
  {
    path: '/head/departments/:department/reviews',
    title: 'Reviews',
    requiredRoles: [userRoles.HEAD],
    component: () => <HeadPageTemplateV3 component={ReviewsPageV3} title="Reviews" />,
  },
  {
    path: '/v1-head/departments/:department/reviews',
    title: 'Reviews (Legacy)',
    requiredRoles: [userRoles.HEAD],
    component: ({ crumbs }) => (
      <HeadPageTemplate crumbs={crumbs} component={ReviewsPage} title="Reviews" />
    ),
  },
  {
    path: '/head/departments/:department/reviews/:reviewId',
    title: 'Reviews',
    requiredRoles: [userRoles.HEAD],
    component: () => <HeadPageTemplateV3 component={SpecificReviewV3} title="Review" />,
  },
  {
    path: '/v1-head/departments/:department/reviews/:reviewId',
    title: 'Reviews (Legacy)',
    requiredRoles: [userRoles.HEAD],
    component: ({ crumbs }) => (
      <HeadPageTemplate crumbs={crumbs} component={SpecificReview} title="Reviews" />
    ),
  },
  {
    path: '/head/departments/:department/review-history',
    title: 'Review History',
    requiredRoles: [userRoles.HEAD],
    component: () => <HeadPageTemplateV3 component={ReviewHistoryPageV3} title="Review History" />,
  },
  {
    path: '/v1-head/departments/:department/review-history',
    title: 'Review History (Legacy)',
    requiredRoles: [userRoles.HEAD],
    component: ({ crumbs }) => (
      <HeadPageTemplate crumbs={crumbs} component={ReviewHistoryPage} title="Review History" />
    ),
  },
  {
    path: '/head/departments/:department/dashboard',
    title: 'Dashboard',
    requiredRoles: [userRoles.HEAD],
    component: () => <HeadPageTemplateV3 component={HeadDashboardPageV3} title="Dashboard" />,
  },
  {
    path: '/v1-head/departments/:department/dashboard',
    title: 'Dashboard (Legacy)',
    requiredRoles: [userRoles.HEAD],
    component: ({ crumbs }) => (
      <HeadPageTemplate crumbs={crumbs} component={HeadDashboardPage} title="Dashboard" />
    ),
  },
];

export default adminRoutes;
